"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@xstate/react");
const react_2 = __importStar(require("react"));
const JoinWaitlist_1 = __importDefault(require("../JoinWaitlist/JoinWaitlist"));
const react_intl_1 = require("react-intl");
const provider_components_1 = require("@kyruus/provider-components");
const messages_1 = __importDefault(require("../../lib/messages"));
const Actions_1 = require("../../lib/constants/Actions");
const RegisterPatientForWaitlist = (0, react_2.forwardRef)(({ service }, ref) => {
    var _a;
    const [state, send] = (0, react_1.useService)(service);
    const localRefToContainer = (0, react_2.useRef)(null);
    const { provider, featureFlags, waitlist, updatedFields } = state.context;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    // Read values directly from the state machine's context
    const optInValue = (waitlist === null || waitlist === void 0 ? void 0 : waitlist.optIn) || false;
    const phoneValue = (waitlist === null || waitlist === void 0 ? void 0 : waitlist.mobileNumber) ||
        ((_a = updatedFields === null || updatedFields === void 0 ? void 0 : updatedFields['patient.phone.number']) === null || _a === void 0 ? void 0 : _a.value) ||
        '';
    const waitlistErrors = (waitlist === null || waitlist === void 0 ? void 0 : waitlist.errors) || [];
    /* useImperativeHandle exposes validateWaitlist and scrollToView methods to parent components via ref
     * validateWaitlist checks if the waitlist can be submitted based on the current state.
     * If the user has opted in, it checks for errors in the waitlistErrors array.
     * If there are errors, it sends an action to update the waitlist errors in the state machine.
     * If the phone number is not provided, it adds an error message and sends it to the state machine.
     */
    (0, react_2.useImperativeHandle)(ref, () => ({
        validateWaitlist: () => {
            if (!optInValue) {
                return { isValid: true };
            }
            if (waitlistErrors.length > 0) {
                send({
                    type: Actions_1.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD_ERRORS,
                    data: {
                        mobileNumber: phoneValue,
                        optIn: optInValue,
                        errors: waitlistErrors
                    }
                });
                return { isValid: false, errors: waitlistErrors };
            }
            if (!phoneValue) {
                const errors = [];
                errors.push(formatMessage(messages_1.default.phoneNumberIsRequiredValidationMessage));
                send({
                    type: Actions_1.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD_ERRORS,
                    data: {
                        mobileNumber: phoneValue,
                        optIn: optInValue,
                        errors: errors
                    }
                });
                return { isValid: false, errors };
            }
            return { isValid: true };
        },
        scrollToView: () => {
            if (localRefToContainer.current) {
                localRefToContainer.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }
    }));
    if (!(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enable_waitlist)) {
        return null;
    }
    const onWaitlistStatusChange = (status) => {
        send({
            type: Actions_1.SET_WAITLIST_OPTIN_STATUS_FIELD,
            data: { optIn: status, errors: [] }
        });
    };
    const onPhoneNumberChange = (value, errors = []) => {
        const errorsList = errors || [];
        if (!value) {
            errorsList.push(formatMessage(messages_1.default.phoneNumberIsRequiredValidationMessage));
        }
        send({
            type: Actions_1.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD,
            data: {
                mobileNumber: value,
                optIn: true,
                errors: errorsList
            }
        });
    };
    return (react_2.default.createElement("div", { "data-testid": "join-waitlist-container", ref: localRefToContainer },
        react_2.default.createElement(JoinWaitlist_1.default, { isChecked: optInValue, onWaitlistStatusChange: onWaitlistStatusChange, phoneNumber: phoneValue, onPhoneChange: onPhoneNumberChange, errors: waitlistErrors, providerName: (0, provider_components_1.getProviderDisplayName)(provider) })));
});
RegisterPatientForWaitlist.displayName = 'RegisterPatientForWaitlist';
exports.default = RegisterPatientForWaitlist;
//# sourceMappingURL=RegisterPatientForWaitlist.js.map